export enum View {
  Park,
  Square,
  Mountain,
  Sea,
  Unrestricted,
  Forest,
}
